import { styled } from "@mui/material/styles";
import { Icon, Table } from "@mui/material";
import { text } from "body-parser";

export const StyledContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(8),
  justifyContent: "left"
}));

export const StyledHeader = styled("div")(({ theme }) => ({
  width: "35%",
  paddingLeft: "40%"
}));

export const ActionIcon = styled(Icon)(({ theme }) => ({
  verticalAlign: "inherit"
}));

export const InteractionSummary = styled("span")(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginLeft: theme.spacing(8)
}));

export const DurationSummary = styled("div")(({ theme }) => ({
  color: theme.palette.text.secondary,
  padding: `${theme.spacing(1)} 0`,
  fontWeight: theme.typography.fontWeightBold,
  "& span": {
    marginRight: theme.spacing(3)
  }
}));

export const ActionTable = styled(Table)(({ theme }) => ({
  // width: '50%',
  border: "1px solid #E0E0E0",
  marginBottom: theme.spacing(2),
  "& th, td": {
    lineHeight: "1rem",
    padding: theme.spacing(1),
    border: "1px solid #E0E0E0"
  },
  "& th": {
    fontWeight: theme.typography.fontWeightBold
  }
}));
